import { Reveal } from "@/components/Reveal";
import { Marquee } from "@/components/Marquee";
import { Dumbbell, Shirt, Heart } from "lucide-react";

const pillars = [
  { icon: Dumbbell, title: "Fitness", text: "Train smart, eat right and build a body you're proud of." },
  { icon: Shirt, title: "Style", text: "Dress well, fit right and carry yourself with confidence." },
  { icon: Heart, title: "Attraction", text: "Build genuine confidence and attract real connection." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="mx-auto max-w-7xl px-5 pt-16 lg:px-8 lg:pt-24">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">About UpgradeMate</p>
          <h1 className="mt-5 max-w-4xl font-display text-5xl font-extrabold leading-[0.98] tracking-tighter sm:text-6xl">Helping People Improve Every Area of Their Life.</h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            Our guides are designed to provide practical systems that help people improve their fitness, style and relationships. We believe self-improvement shouldn't be complicated or full of hype — it should be clear, actionable and built on what actually works.
          </p>
        </Reveal>
      </section>

      <div className="mt-20"><Marquee /></div>

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
        <div className="grid grid-cols-1 gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.map((p, i) => (
            <Reveal key={i} delay={i * 0.07} className="bg-white">
              <div className="flex h-full flex-col p-8">
                <p.icon className="h-6 w-6" />
                <p className="mt-6 font-display text-xl tracking-tight">{p.title}</p>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-black/10 bg-muted">
        <div className="mx-auto max-w-3xl px-5 py-24 text-center lg:py-32">
          <h2 className="font-display text-3xl tracking-tight sm:text-4xl">Practical systems. Real results.</h2>
          <p className="mt-5 text-muted-foreground">Every guide is written to be read once and used forever. Instant download, lifetime access, and updates whenever we improve them — because your growth never stops.</p>
        </div>
      </section>
    </div>
  );
}
